import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import SPADataTable from '../shared/SPADataTable';
import SectionHeading from '../shared/SPASectionHeading';

type DiskRow = string[];

interface DiskSpaceTableProps {
  headers: string[];
  rows: DiskRow[];
}

const columnHelper = createColumnHelper<DiskRow>();

const parseUsagePercent = (row: DiskRow): number | null => {
  const pctCell = row.find(cell => cell.endsWith('%'));
  if (!pctCell) return null;
  const num = parseInt(pctCell, 10);
  return Number.isNaN(num) ? null : num;
};

const rowClassName = (row: DiskRow) => {
  const usage = parseUsagePercent(row);
  return usage !== null && usage > 80 ? 'tw-text-spa-warning' : '';
};

// AIDEV-NOTE: Renders `df -h` output through SPADataTable, one column per server-sent header.
// Highlights rows where disk usage exceeds 80%.
const DiskSpaceTable = ({ headers, rows }: DiskSpaceTableProps) => {
  if (!headers || headers.length === 0) return null;

  const columns: ColumnDef<DiskRow, unknown>[] = headers.map((header, index) => (
    columnHelper.accessor(row => row[index], { enableSorting: false, header, id: String(index) })
  ));

  return (
    <section>
      <SectionHeading title="Disk Space" />
      <SPADataTable
        columns={columns}
        data={rows}
        defaultSort={[]}
        emptyMessage="No disk space information reported."
        rowClassName={rowClassName}
      />
    </section>
  );
};

export default DiskSpaceTable;
